module.exports = __webpack_public_path__ + "img/matur-dokter.1349c02.png";